export default function industryTestimonials() {
	if ($('.industry-testimonials__slider').length) {
    $('.industry-testimonials__slider').slick({
			arrows: false,
			dots: true,
      appendDots: $('.industry-testimonials .industry-dots'),
			speed: 400,
			autoplay: false,
      autoplaySpeed: 4000,
			infinite: true,
			adaptiveHeight: true,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
		});
  }
}